/* línkè · 强调色中枢（2026-07-02，Telegram 式） =====================
   用户选一个颜色 → <html> 挂 data-accent + 内联 --accent，
   tokens.css 末尾的接管层让 --gold 强调槽（全站 155 处）改喝这个色。
   「跟随主题」= null = 摘掉属性，主题原色复活。
   存 localStorage、每台设备各自记（和主题同待遇，故意不进云同步）。
   ================================================================ */
import { useState, useEffect } from 'react';

export const STORAGE_ACCENT = 'lingke.accent';

/* 预设色板：都挑了中等明度的饱和色，三个主题的底色上均可读。
   id=null 是「跟随主题」（dot 用不到，SideDrawer 里特殊渲染）。 */
export const ACCENT_PRESETS = [
  { id: null, name: '跟随主题' },
  { id: '#ff3d97', name: '玫粉' },
  { id: '#ff7a59', name: '蜜桃' },
  { id: '#e8506e', name: '绯红' },
  { id: '#4fb8a8', name: '青碧' },
  { id: '#5aa7e8', name: '天青' },
  { id: '#a78bfa', name: '薰衣草' },
];

const _listeners = new Set();

function _valid(v) {
  return typeof v === 'string' && /^#[0-9a-fA-F]{6}$/.test(v);
}

export function getAccent() {
  try {
    const v = localStorage.getItem(STORAGE_ACCENT);
    return _valid(v) ? v : null;
  } catch {
    return null;
  }
}

export function applyAccent(hex) {
  const root = document.documentElement;
  if (_valid(hex)) {
    root.style.setProperty('--accent', hex);
    root.setAttribute('data-accent', '');
  } else {
    root.style.removeProperty('--accent');
    root.removeAttribute('data-accent');
  }
}

export function setAccent(hex) {
  const v = _valid(hex) ? hex : null;
  try {
    if (v) localStorage.setItem(STORAGE_ACCENT, v);
    else localStorage.removeItem(STORAGE_ACCENT);
  } catch {}
  applyAccent(v);
  _listeners.forEach((fn) => {
    try {
      fn(v);
    } catch {}
  });
}

/* 启动时（main.jsx，首帧前）恢复上次选色，避免刷新闪回金色。 */
export function applyStoredAccent() {
  applyAccent(getAccent());
}

/* React hook：[accent, setAccent]。null = 跟随主题。 */
export function useAccent() {
  const [accent, set] = useState(() => getAccent());
  useEffect(() => {
    _listeners.add(set);
    return () => _listeners.delete(set);
  }, []);
  return [accent, setAccent];
}
